import { put, select, takeEvery } from 'typed-redux-saga/macro';

import { LOG_AUDIT_EVENT } from '../actions';
import { serviceEmitAuditEvent } from '../services';
import { selectSession } from '../selectors';

export function* auditEmitSaga() {
  yield* takeEvery(LOG_AUDIT_EVENT, function* ({ payload }) {
    // The event's own document wins where it names one. Watchers driven by a
    // user action leave it out and mean "the document they acted on", which is
    // the open one; the burn-in names it explicitly because it outlives a
    // document switch and would otherwise file its record against whatever the
    // editor happens to be showing when the export finishes (VE-28061).
    const session = yield* select(selectSession);
    const tdoId = payload.tdoId ?? session?.tdoId;
    if (!tdoId) {
      return;
    }

    // Fire-and-forget: dispatching a thunk via put lets the thunk middleware
    // invoke the GraphQL mutation without blocking the saga.
    yield* put(
      serviceEmitAuditEvent(tdoId, payload.action, payload.payload) as any
    );
  });
}
